import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionService } from '../session.service.js';
import { HttpParams } from "@angular/common/http";
import { PageEvent } from '@angular/material/paginator';
import { SortEvent } from 'allai-admin-shared';
import { DateUtils } from '@allaihealth/util';
import { DateRange } from '@angular/material/datepicker';

/** Service that manages the appointments list filters to maintain their changes and reloading */
@Injectable({
	providedIn: 'root'
})
export class UsersFilterService {

	private _metricsStart: Date;

	private _metricsEnd: Date;

	/** Pager for list views */
	private _pageEvent: PageEvent;

	/** Global Search */
	private _globalSearch: string;

	/** Global Search */
	private _sortOrder: SortEvent;

	/** Subject for filter changes */
	private onNewFilterSubject: Subject<void> = new Subject<void>();

	private onNewDetailFilterSubject: Subject<void> = new Subject<void>();

	constructor(private sessionService: SessionService) {
		//clear on login
		this.sessionService.onLogin.subscribe(() => this.clear());
	}

	/** Dispatch an event on a change */
	private setChanged(savePage?: boolean) {
		if (!savePage) {
			this._pageEvent = null;
		}
		this.onNewFilterSubject.next();
	}

	/** Dispatch an event on a change */
	private setDetailChanged(savePage?: boolean) {
				this.onNewDetailFilterSubject.next();
	}

	/** Clear all saved filters and {@link localStorage} */
	clear() {
	}

	set pageEvent(pageEvent: PageEvent) {
		this._pageEvent = pageEvent;
		this.setChanged(true);
	}

	get pageEvent(): PageEvent {
		if (!this._pageEvent) {
			this._pageEvent = {
				pageIndex: 0,
				pageSize: 10,
				length: 100
			}
		}
		return this._pageEvent;
	}

	set globalSearch(globalSearch: string) {
		this._globalSearch = globalSearch;
		this.setChanged();
	}

	get globalSearch(): string {
		if (!this._globalSearch) {
			this._globalSearch = '';
		}
		return this._globalSearch;
	}

	set sortOrder(sortOrder: SortEvent) {
		this._sortOrder = sortOrder;
		this.setChanged();
	}

	get sortOrder(): SortEvent {
		if (!this._sortOrder) {
			this._sortOrder = {
				active: '',
				direction: ''
			};
		}
		return this._sortOrder;
	}

	/** Dispatched for filter changes */
	get onNewFilter() {
		return this.onNewFilterSubject.asObservable();
	}
	get onNewDetailFilter() {
		return this.onNewDetailFilterSubject.asObservable();
	}

	get metricsStartDate(): Date {
		if (!this._metricsStart) {
			this._metricsStart = new Date();
			this._metricsStart.setDate(this._metricsStart.getDate() - 360);
		}
		return this._metricsStart;
	}

	get metricsEndDate(): Date {
		if (!this._metricsEnd) {
			this._metricsEnd = new Date();
		}
		return this._metricsEnd;
	}

	set metricsRange(dateRange: DateRange<Date>) {
		if(dateRange.start && dateRange.end) {
			this._metricsStart = dateRange.start;
			this._metricsEnd = dateRange.end;
			this.setDetailChanged();
		}
	}
	/** Get the query parameters for a request to the backend server */
	get params(): HttpParams {
		let params: HttpParams = new HttpParams();

		const pageEvent = this.pageEvent;
		const sort: SortEvent = this.sortOrder;

		params = params.set("pageIndex", pageEvent.pageIndex);
		params = params.set("pageSize", pageEvent.pageSize);
		params = params.set("globalSearch", this.globalSearch);
		params = params.set("orderBy", sort.active);
		params = params.set("direction", sort.direction);

		return params;
	}

	get detailParams() {
		let params: HttpParams = new HttpParams();

		const zone = this.sessionService.organization.time_zone;
		const metricsStart = DateUtils.setZonedStartEndDate(this.metricsStartDate, true, zone).toMillis();
		const metricsEnd = DateUtils.setZonedStartEndDate(this.metricsEndDate, true, zone).toMillis();

		params = params.set("metricsStart",metricsStart);
		params = params.set("metricsEnd",metricsEnd);

		return params;
	}
}
